module.exports = __webpack_public_path__ + "img/calender_white.decccd9.png";